var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPocketLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 110 183",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 632.69,
    y: 18.2,
    width: 60.04,
    height: 120.65,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pktlogorounded_rgb-f",
    "data-name": "pktlogorounded rgb-f"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "pktlogorounded_rgb-e",
    "data-name": "pktlogorounded rgb-e",
    points: "632.69 18.2 692.73 18.2 692.73 138.85 632.69 138.85 632.69 18.2",
    fill: "#fff",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    x: 462.32,
    y: 0,
    width: 73.76,
    height: 139.14,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pktlogorounded_rgb-d",
    "data-name": "pktlogorounded rgb-d"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "pktlogorounded_rgb-c",
    "data-name": "pktlogorounded rgb-c",
    points: "462.32 0 536.08 0 536.08 139.13 462.32 139.13 462.32 0",
    fill: "#fff",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-3",
    x: 145.04,
    y: 41.84,
    width: 96.63,
    height: 141.1,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pktlogorounded_rgb-b",
    "data-name": "pktlogorounded rgb-b"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "pktlogorounded_rgb-a",
    "data-name": "pktlogorounded rgb-a",
    points: "145.04 41.84 241.67 41.84 241.67 182.94 145.04 182.94 145.04 41.84",
    fill: "#fff",
    fillRule: "evenodd"
  }))))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Pocket Logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "logo",
    d: "M84.06,83.31l-25.52,24a6.69,6.69,0,0,1-4.88,2.07,7.22,7.22,0,0,1-5.25-2.07l-25.14-24a7.59,7.59,0,0,1,0-10.51c2.81-2.63,7.5-3,10.32,0L53.66,92.13,74.11,72.8c2.63-3,7.32-2.63,10,0a8,8,0,0,1,0,10.51M97,43.53H10.32A10.1,10.1,0,0,0,0,53.47V85.56c0,29.08,24,53.29,53.66,53.29A53.5,53.5,0,0,0,107,85.56V53.47A9.89,9.89,0,0,0,97,43.53",
    fill: "#ef4056",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPocketLogo);
export default __webpack_public_path__ + "static/media/pocket-logo.13d3f322a4f0a2856ca003e04df60654.svg";
export { ForwardRef as ReactComponent };